import React from 'react';
import { motion } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface BenefitCardProps {
  icon: BoxIcon;
  title: string;
  description: string;
  index: number;
}
export function BenefitCard({
  icon: Icon,
  title,
  description,
  index
}: BenefitCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5,
    delay: index * 0.1
  }} viewport={{
    once: true
  }} className="group relative bg-gradient-to-br from-white/5 to-white/0 backdrop-blur-sm border border-white/10 rounded-2xl p-8 hover:border-[#d4af37]/50 transition-all duration-300" data-id="element-100">
      <div className="absolute inset-0 bg-gradient-to-br from-[#d4af37]/0 to-[#d4af37]/0 group-hover:from-[#d4af37]/5 group-hover:to-[#d4af37]/0 rounded-2xl transition-all duration-300" data-id="element-101" />
      <div className="relative" data-id="element-102">
        <div className="w-14 h-14 bg-gradient-to-br from-[#d4af37] to-[#f4d03f] rounded-xl flex items-center justify-center mb-6" data-id="element-103">
          <Icon className="w-7 h-7 text-black" data-id="element-104" />
        </div>
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-105">{title}</h3>
        <p className="text-gray-400 leading-relaxed" data-id="element-106">{description}</p>
      </div>
    </motion.div>;
}